export default __webpack_public_path__ + "static/media/md.f9e23f66.svg";